module.exports = __webpack_public_path__ + "static/cabane-e49941048bfd76106359382a7622e75b.png";